<template>
  <icon-airplane v-if="icon === 'airplane'" />
  <icon-back v-else-if="icon === 'back'" />
  <icon-chevron-down v-else-if="icon === 'chevron-down'" />
  <icon-chevron-up v-else-if="icon === 'chevron-up'" />
  <icon-delete v-else-if="icon === 'delete'" />
  <icon-done v-else-if="icon === 'done'" />
  <icon-download v-else-if="icon === 'download'" />
  <icon-eye v-else-if="icon === 'eye'" />
  <icon-eye-off v-else-if="icon === 'eye-off'" />
  <icon-plus v-else-if="icon === 'plus'" />
  <icon-security v-else-if="icon === 'security'" />
  <icon-warning v-else-if="icon === 'warning'" />
  <icon-airplane v-else />
</template>

<script>
import IconAirplane from './icons/IconAirplane.vue'
import IconBack from './icons/IconBack.vue'
import IconChevronDown from './icons/IconChevronDown.vue'
import IconChevronUp from './icons/IconChevronUp.vue'
import IconDelete from './icons/IconDelete.vue'
import IconDone from './icons/IconDone.vue'
import IconDownload from './icons/IconDownload.vue'
import IconEye from './icons/IconEye.vue'
import IconEyeOff from './icons/IconEyeOff.vue'
import IconPlus from './icons/IconPlus.vue'
import IconSecurity from './icons/IconSecurity.vue'
import IconWarning from './icons/IconWarning.vue'
export default {
  components: {
    IconAirplane,
    IconBack,
    IconDone,
    IconEye,
    IconEyeOff,
    IconChevronDown,
    IconChevronUp,
    IconSecurity,
    IconWarning,
    IconPlus,
    IconDelete,
    IconDownload
  },
  name: 'LgkIcon',
  props: {
    icon: {
      type: String,
      default: 'airplane'
    }
  }
}
</script>
